/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getConfigForPath } from './ApplicationConfigHelper';
import { useAppShellContext } from '../hooks/AppShellContext';

const AppShellLink = ({ children, to, href, ...rest }) => {
  const applicationContext = useAppShellContext();
  const { pathname } = useLocation();

  const effectiveTo = to || href || '';

  let longestPrefix = '';
  let revisedTo = effectiveTo;

  const applications = getConfigForPath(applicationContext, pathname);

  for (const [path, target] of Object.entries(applications.modules)) {
    if (effectiveTo.startsWith(path) && path.length > longestPrefix.length) {
      if (typeof target === 'string') {
        revisedTo = target + path + effectiveTo.substring(path.length);
      } else {
        revisedTo = null;
      }
      longestPrefix = path;
    }
  }

  if (revisedTo !== null) {
    return (
      <a {...rest} href={revisedTo}>
        {children}
      </a>
    );
  }
  return (
    <Link {...rest} to={effectiveTo}>
      {children}
    </Link>
  );
};

AppShellLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  href: PropTypes.string
};

export default AppShellLink;
